/* eslint-disable */
import React from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import MisconceptionCards, {
  MISCONCEPTION_CARD_ICONS,
} from '../../components/MisconceptionCards';
import MisconceptionRiskCarousel from '../../components/MisconceptionRiskCarousel';
interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  const handleMisconceptionCardsComplete = React.useCallback(() => {
    console.log('handleMisconceptionCardsComplete');
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-ics-section1-1'
    );
  }, [updateComponentState, p_course, p_topic, ID]);
  // const handleMisconceptionRiskCarouselComplete = React.useCallback(() => {
  //   updateComponentState(
  //     p_course,
  //     p_topic,
  //     ID,
  //     'student-training-ics-section1-2'
  //   );
  // }, [updateComponentState, p_course, p_topic, ID]);
  return (
    <div className="topic-section-1">
      <MisconceptionCards
        title={paragraphsSettings?.title}
        items={paragraphsSettings?.risks}
        tips={paragraphsSettings?.risksTips}
        icons={MISCONCEPTION_CARD_ICONS}
        id="student-training-ics-section1-1"
        onComplete={handleMisconceptionCardsComplete}
      />
      <MisconceptionRiskCarousel
        id="student-training-ics-section1-2"
        title={paragraphsSettings?.l1RightListTitle}
        tips={paragraphsSettings?.l1RightListDesc}
        items={paragraphsSettings?.l1RightList}
      />
    </div>
  );
};

export default Section1;
